import Vue from 'vue'

const invoiceTypeFormats = {
  invoiceType: (value) => {
    const types = {
      'ROR': 'RoR Ritfactuur',
      'INVOICE': 'Factuur',
      'CREDIT': 'Creditfactuur',
      'CANCEL_CREDIT': 'Creditfactuur',
      'ROR_BO_P': 'RoR Productfactuur',
      'ROR_CREDIT': 'RoR Creditfactuur',
      'EXCHANGE_CARD': 'RoR Factuur vervangende Goede Zaakpas'
    }

    return types[value]
  },
  invoiceSpecificationType: (value) => {
    const types = {
      'ROR': 'RoR Ritfactuur Specificatie',
      'INVOICE': 'Factuur',
      'ROR_BO_P': 'RoR Productfactuur Specificatie'
    }

    return types[value]
  },
  invoiceDocumentTypeIconClass: (value) => {
    const types = {
      pdf: 'icon pdf',
      excel: 'icon csv',
      csv: 'icon realcsv'
    }

    return types[value]
  }
}

Vue.filter('invoiceType', invoiceTypeFormats.invoiceType)
Vue.filter('invoiceSpecificationType', invoiceTypeFormats.invoiceSpecificationType)
Vue.filter('invoiceDocumentTypeIconClass', invoiceTypeFormats.invoiceDocumentTypeIconClass)

export default invoiceTypeFormats



// WEBPACK FOOTER //
// ./src/filters/invoice-type.js